import { nextTick } from "vue";
import { createRouter, createWebHistory } from "vue-router";
import { validateLstToken, clearTokenCheckCache } from "@/utils/lstTokenGate";
import { getLstToken, clearLstSession } from "@/utils/lstSessionStorage";
import { startRouteLoading, stopRouteLoading } from "@/utils/pageLoading";
import { isPublicRoutePath } from "@/utils/publicRoutes";
const router = createRouter({
    history: createWebHistory(),
    routes: [
        { path: "/", component: () => import("@/views/Home.vue") },
        { path: "/login", component: () => import("@/views/Login.vue") },
        { path: "/holdings", component: () => import("@/views/Holdings.vue") },
        {
            path: "/trade",
            component: () => import("@/views/TradeHub.vue")
        },
        // 抢购/寄售助手暂时下线（避免页面卡死）
        // {
        //     path: "/trade-assistant",
        //     component: () => import("@/views/PurchaseShelves.vue")
        // },
        // {
        //     path: "/consignment",
        //     component: () => import("@/views/Shelves.vue")
        // },
        { path: "/trade-assistant", redirect: "/holdings" },
        { path: "/consignment", redirect: "/holdings" },
        { path: "/purchase", redirect: "/holdings" },
        { path: "/shelves", redirect: "/holdings" },
        {
            path: "/announcements",
            component: () => import("@/views/Announcements.vue"),
            meta: { public: true }
        },
        {
            path: "/announcements/:id",
            name: "AnnouncementDetail",
            component: () => import("@/views/AnnouncementDetail.vue"),
            meta: { title: "公告详情", public: true }
        },
        {
            path: "/price-monitor",
            name: "PriceMonitor",
            component: () => import("@/views/Pricemonitor.vue"),
            meta: { title: "\u4EF7\u683C\u76EF\u76D8", requiresAuth: true }
        },
        {
            path: "/trade-monitor",
            name: "TradeMonitor",
            component: () => import("@/views/Trademonitor.vue"),
            meta: { title: "\u6210\u4EA4\u76D1\u63A7", requiresAuth: true }
        },
        {
            path: "/price-chart",
            name: "PriceChart",
            component: () => import("@/views/PriceChart.vue"),
            meta: { title: "\u884C\u60C5\u4E2D\u5FC3", requiresAuth: true }
        },
        {
            path: "/trade-volume",
            name: "TradeVolume",
            component: () => import("@/views/TradeVolume.vue"),
            meta: { title: "\u4EA4\u6613\u91CF\u7EDF\u8BA1", requiresAuth: true }
        },
        {
            path: "/hall-of-fame",
            name: "HallOfFame",
            component: () => import("@/views/HallOfFame.vue"),
            meta: { title: "\u540D\u4EBA\u5802", requiresAuth: true }
        },
        { path: "/more", component: () => import("@/views/More.vue") },
        {
            path: "/daily-trading",
            name: "DailyTradingSummary",
            component: () => import("@/views/DailyTradingSummary.vue"),
            meta: { title: "\u5F53\u65E5\u4EA4\u6613\u6C47\u603B", requiresAuth: true }
        },
        {
            path: "/on-sale/:albumId",
            name: "OnSaleList",
            component: () => import("@/views/OnSaleList.vue")
        },
        {
            path: "/album-primary/:albumId",
            name: "AlbumPrimaryDetail",
            component: () => import("@/views/AlbumPrimaryDetail.vue"),
            meta: { title: "\u4E13\u8F91\u8BE6\u60C5" }
        },
        {
            path: "/blind-box/:albumId",
            name: "BlindBoxDetail",
            component: () => import("@/views/BlindBoxDetail.vue"),
            meta: { title: "\u76F2\u76D2" }
        },
        {
            path: "/blind-open/:albumId",
            name: "BlindBoxOpen",
            component: () => import("@/views/BlindBoxOpen.vue"),
            meta: { title: "\u76F2\u76D2\u5F00\u76D2" }
        },
        {
            path: "/blind-pool-item/:albumId",
            name: "BlindPoolItemDetail",
            component: () => import("@/views/BlindPoolItemDetail.vue"),
            meta: { title: "\u5956\u6C60\u8BE6\u60C5" }
        },
        {
            path: "/product/:id",
            name: "ProductDetail",
            component: () => import("@/views/ProductDetail.vue")
        },
        { path: "/sale-record", component: () => import("@/views/SaleRecord.vue") },
        { path: "/wallet", component: () => import("@/views/Wallet.vue") },
        { path: "/user", component: () => import("@/views/UserCenter.vue") },
        {
            path: "/asset-overview",
            name: "AssetOverview",
            component: () => import("@/views/AssetOverviewPage.vue"),
            meta: { title: "资产总览" }
        },
        {
            path: "/profit-analysis",
            name: "ProfitAnalysis",
            component: () => import("@/views/ProfitAnalysisPage.vue"),
            meta: { title: "盈亏分析" }
        },
        {
            path: "/invite-friends",
            name: "InviteFriends",
            component: () => import("@/views/InviteFriends.vue"),
            meta: { title: "邀请好友" }
        },
        {
            path: "/shipping-addresses",
            name: "ShippingAddresses",
            component: () => import("@/views/MyAddresses.vue"),
            meta: { title: "收货地址" }
        },
        {
            path: "/asset-gift",
            name: "AssetGift",
            component: () => import("@/views/AssetGift.vue"),
            meta: { title: "转赠藏品" }
        },
        {
            path: "/kyc",
            name: "KycGuide",
            component: () => import("@/views/KycGuide.vue"),
            meta: { title: "实名认证" }
        },
        {
            path: "/orders",
            name: "OrderList",
            component: () => import("@/views/OrderList.vue"),
            meta: { title: "\u6211\u7684\u8BA2\u5355" }
        },
        {
            path: "/order/:orderId",
            name: "OrderDetail",
            component: () => import("@/views/OrderDetail.vue"),
            meta: { title: "\u8BA2\u5355\u8BE6\u60C5" }
        },
        { path: "/my-assets", component: () => import("@/views/MyAssets.vue") },
        {
            path: "/resell",
            name: "ProductResell",
            component: () => import("@/views/ProductResell.vue"),
            meta: { title: "\u5BC4\u552E", requiresAuth: true }
        },
        { path: "/market", component: () => import("@/views/Market.vue") },
        {
            path: "/data-hall",
            name: "DataHall",
            component: () => import("@/views/DataHall.vue"),
            meta: { title: "\u6570\u636E\u7EDF\u8BA1", requiresAuth: true }
        },
        {
            path: "/data-hall/album-prices",
            name: "DataHallAlbumPrices",
            component: () => import("@/views/DataHallAlbumPrices.vue"),
            meta: { title: "\u6210\u4EA4\u4EF7\u4F4D", requiresAuth: true }
        },
        {
            path: "/blind-collect",
            name: "BlindCollectList",
            component: () => import("@/views/BlindCollectList.vue"),
            meta: { title: "\u96c6\u5361", requiresAuth: true }
        },
        {
            path: "/activity-assistant",
            name: "ActivityAssistantConfig",
            component: () => import("@/views/ActivityAssistantConfig.vue"),
            meta: { title: "\u52A9\u624B\u5B9A\u65F6" }
        },
        {
            path: "/draw-activities",
            name: "DrawActivityList",
            component: () => import("@/views/DrawActivityList.vue"),
            meta: { title: "\u62BD\u7B7E\u6D3B\u52A8" }
        },
        {
            path: "/draw/:drawId",
            name: "DrawActivityDetail",
            component: () => import("@/views/DrawActivityDetail.vue"),
            meta: { title: "\u62BD\u7B7E\u6D3B\u52A8" }
        },
        {
            path: "/draw/:drawId/records",
            name: "DrawRecords",
            component: () => import("@/views/DrawRecords.vue"),
            meta: { title: "\u62BD\u7B7E\u8BB0\u5F55" }
        },
        {
            path: "/decompose/:groupId",
            name: "DecomposeList",
            component: () => import("@/views/DecomposeActivityList.vue"),
            meta: { title: "\u5206\u89E3\u6D3B\u52A8" }
        },
        {
            path: "/decompose/synthetic/:activityId",
            name: "DecomposeSynthetic",
            component: () => import("@/views/DecomposeSyntheticDetail.vue"),
            meta: { title: "\u5206\u89E3", requiresAuth: true }
        },
        /** 按活动 ID 查询分解列表，点击进入与合成一致的全屏分解详情 */
        {
            path: "/decompose/quick",
            name: "DecomposeQuickList",
            component: () => import("@/views/SyntheticCutList.vue"),
            meta: { title: "\u6570\u5b57\u5206\u89e3", requiresAuth: true }
        },
        {
            path: "/synthetic-cut",
            redirect: (to) => ({
                name: "DecomposeList",
                params: { groupId: String(to.query.groupKey || "default") },
                query: { albumId: to.query.albumId }
            })
        },
        {
            path: "/compose/:groupId",
            name: "ComposeList",
            component: () => import("@/views/ComposeActivityList.vue"),
            meta: { title: "\u5408\u6210\u6D3B\u52A8" }
        },
        {
            path: "/compose/synthetic/:activityId",
            name: "ComposeSynthetic",
            component: () => import("@/views/ComposeSyntheticDetail.vue"),
            meta: { title: "\u5408\u6210" }
        },
        {
            path: "/recast/:groupId",
            name: "RecastList",
            component: () => import("@/views/RecastActivityList.vue"),
            meta: { title: "\u7F6E\u6362\u6D3B\u52A8" }
        },
        {
            path: "/recast/synthetic/:activityId",
            name: "RecastSynthetic",
            component: () => import("@/views/RecastSyntheticDetail.vue"),
            meta: { title: "\u7F6E\u6362" }
        },
        {
            path: "/exchange/:groupId",
            name: "ExchangeList",
            component: () => import("@/views/RecastActivityList.vue"),
            meta: { title: "\u5151\u6362\u6D3B\u52A8" }
        },
        {
            path: "/exchange/synthetic/:activityId",
            name: "ExchangeSynthetic",
            component: () => import("@/views/RecastSyntheticDetail.vue"),
            meta: { title: "\u5151\u6362" }
        },
        {
            path: "/activity/play-result",
            name: "SyntheticPlayResult",
            component: () => import("@/views/SyntheticPlayResult.vue"),
            meta: { title: "\u64CD\u4F5C\u7ED3\u679C", requiresAuth: true }
        },
        {
            path: "/points-hub",
            name: "PointsHub",
            component: () => import("@/views/PointsHub.vue"),
            meta: { title: "\u79EF\u5206\u4E0E\u5151\u6362" }
        },
        {
            path: "/points-mall",
            name: "PointsMall",
            component: () => import("@/views/PointsMall.vue"),
            meta: { title: "\u79EF\u5206\u5546\u57CE" }
        },
        {
            path: "/points-mall/transactions",
            name: "PointsTransactionList",
            component: () => import("@/views/PointsTransactionList.vue"),
            meta: { title: "\u79EF\u5206\u660E\u7EC6" }
        },
        {
            path: "/points-mall/album/:albumId",
            name: "PointsAlbumDetail",
            component: () => import("@/views/PointsAlbumDetail.vue"),
            meta: { title: "\u5151\u6362\u8BE6\u60C5" }
        }
    ]
});
const showLoginDialog = (next, redirectFullPath) => {
    const q = redirectFullPath && String(redirectFullPath).startsWith("/") ? { redirect: redirectFullPath } : {};
    return next({ path: "/login", query: q });
};
router.beforeEach(async (to, from, next) => {
    if (to.path !== from.path && from.matched.length > 0) {
        startRouteLoading();
    }
    if (isPublicRoutePath(to.path) || to.matched.some((r) => r.meta?.public)) {
        return next();
    }
    const token = getLstToken();
    if (!token) {
        return showLoginDialog(next, to.fullPath);
    }
    try {
        const res = await validateLstToken();
        if (res.code === 1) {
            return next();
        }
        clearTokenCheckCache();
        clearLstSession();
        return showLoginDialog(next, to.fullPath);
    }
    catch (e) {
        return next();
    }
});
router.afterEach((to, from) => {
    if (to.path !== from.path) {
        nextTick(() => {
            requestAnimationFrame(() => stopRouteLoading());
        });
    }
});
export default router;
